import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EligibleProductStatus } from '@typesApp/Product'
import { closeApp } from '@redux/slices/workflowSlice'
import { eligibleProductStatusSelector } from '@redux/slices/claimStatusSlice'
import { usePageFlow } from '@hooks/usePageFlow'
import { usePathBuilder } from '@hooks/usePathBuilder'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { LoadingSkeleton } from './LoadingSkeleton'
import { useSessionInfo } from '@hooks/useSessionInfo'

export const LoginRedirect: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useAppNavigate()
  const buildPath = usePathBuilder()
  const { loginRedirectView, isReady } = usePageFlow()
  const { isActiveDataChecked, isRestricted, isRestrictedCheckPerformed } = useSessionInfo()
  const productStatus = useSelector(eligibleProductStatusSelector)

  useEffect(() => {
    if (!isActiveDataChecked || !isRestrictedCheckPerformed) return

    if (productStatus === EligibleProductStatus.NOT_ELIGIBLE || isRestricted) {
      dispatch(closeApp())
    } else if (isReady && productStatus === EligibleProductStatus.ELIGIBLE) {
      navigate(buildPath(loginRedirectView))
    }
  }, [
    dispatch,
    navigate,
    buildPath,
    loginRedirectView,
    productStatus,
    isReady,
    isRestricted,
    isRestrictedCheckPerformed,
    isActiveDataChecked,
  ])

  return <LoadingSkeleton />
}
